export const SET_ORDER = "SET_ORDER";
export const SET_BOXES = "SET_BOXES";
export const SET_AWARENESS_STATUS = "SET_AWARENESS_STATUS";



